import React from "react";

function Partners() {
  return (
    <div
      id="partners" // 👈 link target for navbar
      style={{ padding: "60px 20px", backgroundColor: "#fff" }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto", textAlign: "center" }}>
        {/* Section Title */}
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "40px",
            color: "#0c2340",
          }}
        >
          Our Past Performances
        </h2>

        {/* Public Sector */}
        <h3 style={{ fontSize: "1.3rem", marginBottom: "20px", color: "#333" }}>
          Public Sector Customers
        </h3>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "30px",
            marginBottom: "50px",
          }}
        >
          <img src="6.png" alt="Department of Defense" style={{ height: "203px" }} />
          <img src="7.png" alt="Patent & Trademark Office" style={{ height: "203px" }} />
          <img src="8.png" alt="Defense Logistics Agency" style={{ height: "203px" }} />
          <img src="9.png" alt="US Air Force" style={{ height: "203px" }} />
          <img src="10.png" alt="USDA" style={{ height: "203px" }} />
          <img src="14.png" alt="DOJ" style={{ height: "203px" }} />
        </div>

        {/* Commercial Sector */}
        <h3 style={{ fontSize: "1.3rem", marginBottom: "20px", color: "#333" }}>
          Commercial Customers
        </h3>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "40px",
          }}
        >
          <img src="11.png" alt="TD Ameritrade" style={{ height: "90px" }} />
          <img src="12.png" alt="TIBCO" style={{ height: "90px" }} />
          <img src="13.png" alt="Winstar" style={{ height: "90px" }} />
        </div>
      </div>
    </div>
  );
}

export default Partners;
